import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useIsAgencyAdmin } from "@src/hooks/useIsAgencyAdmin";
import { useHasBillableAgencyLink } from "@src/hooks/useHasBillableAgencyLink";

export const useShowBrandManagement = () => {
  const isAdmin = useIsAdmin();
  const isAgencyUser = useIsAgencyAdmin();

  // Only show Brand Management for agency types (managed billing),
  // not for agency_self_billing or aggregator types.
  const hasAgencyTypeLink = useHasBillableAgencyLink();

  return hasAgencyTypeLink && (isAdmin || isAgencyUser);
};
